function Hit(duration) {

    this.name = 'hit';

    this.duration = duration;
    this.elapsed = 0;
}

export {Hit};
